import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  dialogPaper: {
    borderRadius: "16px !important",
    padding: "8px",
    maxWidth: "520px !important",
    width: "100%",
  },
  dialogTitle: {
    fontWeight: "700 !important",
    fontSize: "1.25rem !important",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    color: "#2c3e50",
  },
  infoCard: {
    backgroundColor: "#f8f9fa",
    borderRadius: "12px",
    padding: "16px",
    border: "1px solid #e9ecef",
    marginTop: "8px",
    marginBottom: "16px",
  },
  label: {
    color: "#6c757d",
    fontSize: "12px !important",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  value: {
    color: "#212529",
    fontSize: "14px !important",
    fontWeight: 600,
    marginTop: "2px",
  },
  locationRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    marginTop: "10px",
  },
  locationDot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    marginTop: "5px",
    flexShrink: 0,
  },
  pickupDot: {
    backgroundColor: "#27ae60",
  },
  dropDot: {
    backgroundColor: "#e74c3c",
  },
  badgeHold: {
    backgroundColor: "#e67e22",
    color: "#ffffff",
    padding: "4px 10px",
    borderRadius: "12px",
    fontSize: "11px",
    fontWeight: "bold",
    display: "inline-block",
  },
  noticeBox: {
    backgroundColor: "#e8f4fd",
    borderLeft: "4px solid #3498db",
    padding: "10px 14px",
    borderRadius: "4px",
    fontSize: "13px",
    color: "#2980b9",
    marginTop: "8px",
  },
  approveBtn: {
    backgroundColor: "#27ae60 !important",
    color: "#ffffff !important",
    fontWeight: "600 !important",
    padding: "8px 22px !important",
    borderRadius: "8px !important",
    textTransform: "none !important",
    "&:hover": {
      backgroundColor: "#219653 !important",
    },
  },
  cancelBtn: {
    color: "#6c757d !important",
    fontWeight: "600 !important",
    textTransform: "none !important",
  },
}));

export default useStyles;
